import React from 'react';
import {slugify} from "../../../utils";
import PropTypes from "prop-types";
import {Link} from "react-router-dom";
import { FiUser, FiCalendar, FiImage } from "react-icons/fi";


const BlogList = ({ data, StyleVar }) => {
    // Handle categories - can be array or string (from admin API)
    const categories = Array.isArray(data.categories) 
        ? data.categories 
        : (data.category ? [data.category] : []);
    
    // Handle author - can be array or string (from admin API)
    const authorName = Array.isArray(data.author) 
        ? data.author[0] 
        : (data.author || 'Admin');
    
    // Determine image source - handle both URL and local path
    // If image already has full URL (from backend /uploads/), use it directly
    // Otherwise, check if it's a local path and prepend PUBLIC_URL
    const imageSrc = data.image?.startsWith('http') 
        ? data.image 
        : data.image?.startsWith('/uploads/')
        ? `${process.env.REACT_APP_API_URL || 'http://localhost:3001'}${data.image}`
        : (data.image ? `${process.env.PUBLIC_URL}/${data.image}` : '');

    const imageAlt = data.image_alt_text?.trim() || data.title || 'Blog image';

    // Use slug for URL if available, otherwise use ID (root-level path)
    const detailPath = data.slug
        ? `${process.env.PUBLIC_URL}/${data.slug}`
        : `${process.env.PUBLIC_URL}/${data.id}`;

    const cate = categories.map((value, i) => {
        return (
            <Link to={process.env.PUBLIC_URL + `/category/${slugify(value)}`} key={i}>{value}{i !== categories.length - 1 && ","}</Link>
        )
    });

    
    return (
        <div className={`rn-card ${StyleVar}`}>
            <div className="inner">
                    <div className="thumbnail position-relative" style={{ overflow: 'hidden' }}>
                        <Link to={detailPath} className="image d-block" style={{ textDecoration: 'none' }}>
                            {imageSrc ? (
                                <img 
                                    src={imageSrc}
                                    alt={imageAlt}
                                    className="w-100"
                                    style={{ 
                                        height: '280px', 
                                        objectFit: 'cover',
                                        transition: 'transform 0.3s ease'
                                    }}
                                    onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                                    onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                                />
                            ) : (
                                <div className="d-flex align-items-center justify-content-center blog-placeholder" style={{
                                    width: '100%', 
                                    height: '280px',
                                    border: '1px dashed var(--color-border)',
                                    fontSize: '14px',
                                    backgroundColor: 'var(--color-darker)',
                                    color: 'var(--color-body)',
                                    transition: 'all 0.3s ease'
                                }}>
                                    <FiImage style={{ fontSize: '2rem', opacity: 0.3 }} />
                                </div>
                            )}
                        </Link>
                        {categories.length > 0 && (
                            <div className="position-absolute top-0 start-0 m-3">
                                {categories.slice(0, 2).map((value, i) => (
                                    <Link 
                                        key={i}
                                        to={process.env.PUBLIC_URL + `/category/${slugify(value)}`}
                                        className="badge bg-primary text-white text-decoration-none me-1"
                                        style={{ 
                                            fontSize: '0.75rem',
                                            padding: '6px 12px',
                                            borderRadius: '20px',
                                            fontWeight: '500'
                                        }}
                                    >
                                        {value}
                                    </Link>
                                ))}
                            </div>
                        )}
                    </div>
                    <div className="content">
                        <div className="d-flex align-items-center mb-3 blog-meta" style={{ 
                            fontSize: '0.875rem',
                            color: 'var(--color-body)',
                            transition: 'color 0.3s ease'
                        }}>
                            <Link 
                                to={process.env.PUBLIC_URL + `/archive/${slugify(authorName)}`}
                                className="text-decoration-none d-flex align-items-center me-3"
                                style={{ 
                                    color: 'var(--color-body)',
                                    transition: 'color 0.3s ease'
                                }}
                            >
                                <FiUser className="me-1" style={{ fontSize: '14px' }} />
                                <span>{authorName}</span>
                            </Link>
                            <span style={{ color: 'var(--color-body)' }}>|</span>
                            <span className="ms-3 d-flex align-items-center" style={{ color: 'var(--color-body)' }}>
                                <FiCalendar className="me-1" style={{ fontSize: '14px' }} />
                                {data.date}
                            </span>
                        </div>
                        <h4 className="title mb-0 blog-title" style={{ 
                            fontSize: '1.5rem', 
                            fontWeight: '600', 
                            lineHeight: '1.4'
                        }}>
                            <Link 
                                to={detailPath}
                                className="text-decoration-none blog-title-link"
                                style={{ 
                                    color: 'var(--color-heading)',
                                    transition: 'color 0.3s ease'
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.color = 'var(--color-primary, #059DFF)'}
                                onMouseLeave={(e) => e.currentTarget.style.color = 'var(--color-heading)'}
                            >
                                {data.title}
                            </Link>
                        </h4>
                    </div>
                </div>
        </div>
    )
}
BlogList.propTypes = {
    data: PropTypes.object
};
export default BlogList;
